var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ies-form-field",
    { attrs: { field: _vm.field } },
    [
      _c("v-autocomplete", {
        attrs: {
          "hide-details": "",
          dense: "",
          outlined: "",
          items: _vm.userAssociationTypes,
          autocomplete: "",
        },
        model: {
          value: _vm.viewValue,
          callback: function ($$v) {
            _vm.viewValue = $$v
          },
          expression: "viewValue",
        },
      }),
      _vm._v(" "),
      _c("input", {
        attrs: {
          type: "hidden",
          name: _vm.field.fieldName,
          text: _vm.field.text,
        },
        domProps: { value: _vm.field.value },
      }),
      _vm._v(" "),
      _vm.errorMessages && _vm.errorMessages.length
        ? _c(
            "v-alert",
            { attrs: { type: "error", dismissable: "", value: "true" } },
            _vm._l(_vm.errorMessages, function (error, index) {
              return _c("div", { key: index }, [
                _vm._v(_vm._s(error.reason) + "*"),
              ])
            }),
            0
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }